export const DraggableColumnTypes = {
  SUBMISSION_RELATED_SELECTION: "submission_related_selection",
  TASK_DEFAULT_SELECTION: "task_default_selection",
  TASK_QUESTION_SELECTION: "task_question_selection",
  TASK_FORM_SELECTION: "task_form_selection",
}
